export default __webpack_public_path__ + "static/media/1925.b60cd0f0.png";